const spacingAliases = {
  m: ['margin'],
  mt: ['marginTop'],
  mr: ['marginRight'],
  mb: ['marginBottom'],
  ml: ['marginLeft'],
  mx: ['marginLeft', 'marginRight'],
  my: ['marginTop', 'marginBottom'],
  p: ['padding'],
  pt: ['paddingTop'],
  pr: ['paddingRight'],
  pb: ['paddingBottom'],
  pl: ['paddingLeft'],
  px: ['paddingLeft', 'paddingRight'],
  py: ['paddingTop', 'paddingBottom'],
};

const passthroughAliases = {
  bgcolor: 'backgroundColor',
};

// Keys whose numeric values are on the MUI 8px spacing scale.
const gapAliases = new Set(['gap', 'rowGap', 'columnGap']);

// Keys whose string values may be MUI palette tokens ('text.secondary', ...).
const colorKeys = new Set([
  'color',
  'backgroundColor',
  'borderColor',
  'borderTopColor',
  'borderRightColor',
  'borderBottomColor',
  'borderLeftColor',
  'outlineColor',
  'textDecorationColor',
  'caretColor',
  'fill',
  'stroke',
]);

const PALETTE_TOKEN_PATTERN = /^(text|primary|secondary|error|warning|info|success|grey|background|common|action)\.([A-Za-z0-9]+)$/;
const BARE_COLOR_TOKENS = new Set(['primary', 'secondary', 'error', 'warning', 'info', 'success']);

// Resolve MUI palette tokens to the CSS variables defined in palette.less.
export const paletteValue = (value) => {
  if (typeof value !== 'string') return null;
  if (value === 'divider') return 'var(--ls-palette-divider, rgba(0, 0, 0, 0.12))';
  if (BARE_COLOR_TOKENS.has(value)) return `var(--ls-palette-${value}-main)`;
  const match = value.match(PALETTE_TOKEN_PATTERN);
  if (!match) return null;
  return `var(--ls-palette-${match[1]}-${match[2]})`;
};

export const spacingValue = (value) => {
  if (value == null) return undefined;
  if (typeof value === 'number') return `${value * 8}px`;
  return value;
};

// Material Design elevation shadows (MUI's default theme.shadows).
export const ELEVATION_SHADOWS = [
  'none',
  '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
  '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
  '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
  '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
  '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
  '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
  '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
  '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
  '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
  '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
  '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
  '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
  '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
  '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
  '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
  '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
  '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
  '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
  '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
  '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
  '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
  '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
  '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
  '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
];

export const elevationShadow = (elevation = 1) => (
  ELEVATION_SHADOWS[Math.min(Math.max(Number(elevation) || 0, 0), 24)]
);

// MUI Box/Stack accept system props directly (<Box display="flex" p={2}>).
// splitSystemProps separates those from real DOM props so the primitives can
// route them through sxToStyle.
const SYSTEM_PROP_KEYS = new Set([
  ...Object.keys(spacingAliases),
  'gap', 'rowGap', 'columnGap',
  'display', 'width', 'height', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight',
  'flex', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection', 'flexWrap',
  'alignItems', 'alignContent', 'alignSelf', 'justifyContent', 'justifyItems', 'justifySelf',
  'bgcolor', 'color', 'borderRadius', 'border', 'borderColor', 'boxShadow',
  'position', 'top', 'left', 'right', 'bottom', 'zIndex',
  'overflow', 'overflowX', 'overflowY',
  'textAlign', 'whiteSpace', 'lineHeight', 'fontWeight', 'fontSize', 'fontStyle',
  'letterSpacing', 'textTransform', 'cursor', 'opacity', 'visibility',
]);

export const splitSystemProps = (props) => {
  const system = {};
  const rest = {};
  for (const [key, value] of Object.entries(props)) {
    if (SYSTEM_PROP_KEYS.has(key)) system[key] = value;
    else rest[key] = value;
  }
  return { system, rest };
};

// Resolve one sx entry to its CSS declarations ({ cssProp: cssValue }).
const resolveSxEntry = (key, value) => {
  const spacingKeys = spacingAliases[key];
  if (spacingKeys) {
    const resolved = spacingValue(value);
    return Object.fromEntries(spacingKeys.map((spacingKey) => [spacingKey, resolved]));
  }

  if (gapAliases.has(key)) {
    return { [key]: spacingValue(value) };
  }

  const resolvedKey = passthroughAliases[key] || key;

  if (colorKeys.has(resolvedKey)) {
    return { [resolvedKey]: paletteValue(value) || value };
  }

  // MUI multiplies numeric borderRadius by theme.shape.borderRadius (4px).
  if (resolvedKey === 'borderRadius' && typeof value === 'number') {
    return { [resolvedKey]: `${value * 4}px` };
  }

  // MUI's border system prop turns numbers into solid borders.
  if (typeof value === 'number' && /^border(Top|Right|Bottom|Left)?$/.test(resolvedKey)) {
    return { [resolvedKey]: `${value}px solid` };
  }

  // MUI maps numeric boxShadow values onto theme.shadows elevations.
  if (resolvedKey === 'boxShadow' && typeof value === 'number') {
    return { boxShadow: elevationShadow(value) };
  }

  // Pass other values through untouched: React's style handling already
  // matches MUI here (px for dimensional numbers, unitless for fontWeight,
  // zIndex, opacity, flex, ...). Scaling every number by 8px broke those.
  return { [resolvedKey]: value };
};

const BREAKPOINT_ORDER = ['xs', 'sm', 'md', 'lg', 'xl'];

const isResponsiveValue = (value) => (
  value != null
  && typeof value === 'object'
  && !Array.isArray(value)
  && Object.keys(value).length > 0
  && Object.keys(value).every((key) => BREAKPOINT_ORDER.includes(key))
);

export const sxToStyle = (sx) => {
  if (!sx || typeof sx !== 'object' || Array.isArray(sx)) return {};

  return Object.entries(sx).reduce((style, [key, value]) => {
    if (value == null || typeof value === 'object') return style;
    return Object.assign(style, resolveSxEntry(key, value));
  }, {});
};

// --- Responsive sx support ----------------------------------------------
// MUI sx values may be breakpoint objects ({ xs: 2, md: 4 }). Inline styles
// cannot express media queries, so responsive entries compile to a cached,
// runtime-injected CSS class (the same approach as core/responsive-runtime).
// Breakpoints match MUI defaults: sm 600, md 900, lg 1200, xl 1536.
const RSX_STYLE_ID = 'ls-ui-web-rsx-styles';
const RSX_BREAKPOINT_MIN_WIDTHS = { sm: 600, md: 900, lg: 1200, xl: 1536 };
const rsxClassCache = new Map();
let rsxCounter = 0;

const toKebabCase = (key) => key.replace(/[A-Z]/g, (ch) => `-${ch.toLowerCase()}`);

const declarationsToCss = (declarations) => Object.entries(declarations)
  .filter(([, value]) => value !== undefined && value !== null)
  .map(([prop, value]) => `${toKebabCase(prop)}: ${typeof value === 'number' ? `${value}px` : value};`)
  .join(' ');

const injectRsxRule = (cssText) => {
  if (rsxClassCache.has(cssText)) return rsxClassCache.get(cssText);
  rsxCounter += 1;
  const className = `ls-rsx-${rsxCounter}`;
  rsxClassCache.set(cssText, className);
  if (typeof document !== 'undefined') {
    let styleEl = document.getElementById(RSX_STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = RSX_STYLE_ID;
      document.head.appendChild(styleEl);
    }
    styleEl.textContent += cssText.replaceAll('__CLASS__', className);
  }
  return className;
};

// Resolve a full sx object (plus optional system props) into an inline style
// for static entries and an injected class for responsive entries.
export const resolveSx = (...sxObjects) => {
  const style = {};
  const perBreakpoint = {};

  for (const sx of sxObjects) {
    if (!sx || typeof sx !== 'object' || Array.isArray(sx)) continue;
    for (const [key, value] of Object.entries(sx)) {
      if (value == null) continue;
      if (isResponsiveValue(value)) {
        for (const [breakpoint, bpValue] of Object.entries(value)) {
          if (bpValue == null) continue;
          perBreakpoint[breakpoint] = Object.assign(
            perBreakpoint[breakpoint] || {},
            resolveSxEntry(key, bpValue),
          );
        }
      } else if (typeof value !== 'object') {
        Object.assign(style, resolveSxEntry(key, value));
      }
    }
  }

  let className;
  const breakpointsUsed = BREAKPOINT_ORDER.filter((bp) => perBreakpoint[bp]);
  if (breakpointsUsed.length) {
    const rules = breakpointsUsed.map((bp) => {
      const body = `.__CLASS__ { ${declarationsToCss(perBreakpoint[bp])} }`;
      const minWidth = RSX_BREAKPOINT_MIN_WIDTHS[bp];
      return minWidth ? `@media (min-width: ${minWidth}px) { ${body} }` : body;
    }).join('\n');
    className = injectRsxRule(`\n${rules}`);
  }

  return { style, className };
};
